import { C } from "@hikari/vault-core";

export default function Banner() {
    return (
        <div
            style={{
                background: "#0E1318",
                borderBottom: `1px solid ${C.border}`,
                color: C.muted,
                fontFamily: C.font,
                fontSize: "0.78rem",
                letterSpacing: "0.05em",
                padding: "0.55rem 1rem",
                textAlign: "center",
            }}
        >
            <span style={{ color: C.accent }}>● PRIVATE BETA</span>
            &nbsp;·&nbsp; v0.1 — invite-only. Crypto seed validation, attachments &amp; Shamir trustees shipping soon.
        </div>
    );
}
